import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  DateInput,
  SelectInput,
  ReferenceInput,
} from "react-admin";

export const UserCreate = (props) => {
  return (
    <Create title="Crear Usuario" {...props}>
      <SimpleForm>
        <TextInput source="firstName" label="Nombre" />
        <TextInput source="lastName" label="Apellido" />
        <TextInput source="email" label="Correo Electrónico" />
        <TextInput source="phone" label="Celular" />
        <DateInput source="birthDate" label="Fecha de nacimiento" />
        <TextInput source="password_hash" label="Contraseña" type="password" />
        
        <ReferenceInput label="Rol" source="roleId" reference="roles">
  <SelectInput optionText="name" />
</ReferenceInput>

      </SimpleForm>
    </Create>
  );
};
